import dayjs from "dayjs";
import React from "react";
import Link from "next/link";
import { imageSizerString } from "lib/fun";
import { useDevice } from "contexts/deviceContext";
import classNames from "classnames";
import { getArticlePath } from "common";

import styles from "./ArticleCard.module.scss";
import { ArticleItemFragment } from "../../../generated/graphql";
import backupImage from "../../../../assets/images/img_not_found.svg";

interface Props {
  article: ArticleItemFragment;
  type?: "normal" | "stretched";
  noColorTitle?: boolean;
}

const ArticleCard: React.FC<Props> = ({
  article,
  type = "normal",
  noColorTitle = false,
}) => {
  const device = useDevice();
  const isMobile = device === "mobile";
  const maybeEntrySheetImage =
    article.category.id === 4
      ? "https://images.en-courage.com/regC8iQobP03FmGjvr5oh58PHfK3lgTT1okJwKG5F7aGaBIooeFfsl4JVQb5hz4O.png"
      : null;

  return (
    <Link href={getArticlePath(String(article.id))}>
      {type === "stretched" ? (
        <a {...{ "data-e2e": "article-list-article-card" }}>
          <div className={styles.articleStretched}>
            <div className={styles.articleImgStretched}>
              {/* article size ratio is always 2:1(width:height) */}
              <img
                src={`${imageSizerString(
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  maybeEntrySheetImage || article.imageUrl || backupImage,
                  !isMobile ? 250 : 150,
                  !isMobile ? 125 : 75,
                )}`}
              />
            </div>
            <div className={styles.articleDescriptionStretched}>
              <div className={styles.articleTitle}>{article.title}</div>
              <div className={styles.articleExtra}>{article.category.name}</div>
            </div>
          </div>
        </a>
      ) : (
        <a {...{ "data-e2e": "article-list-article-card" }}>
          <div className={styles.articleImg}>
            <img
              src={`${imageSizerString(
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                maybeEntrySheetImage || article.imageUrl || backupImage,
                500,
                250,
              )}`}
            />
          </div>
          <div className={styles.articleDescription}>
            <div
              className={classNames(
                noColorTitle ? styles.articleTitleBlack : styles.articleTitle,
              )}
            >
              {article.title}
            </div>
            <div className={styles.articleExtra}>
              {`${dayjs(article.publishAt).format(
                "YYYY/MM/DD[(]dd[)] HH:mm",
              )} - ${article.category.name}`}
            </div>
          </div>
        </a>
      )}
    </Link>
  );
};

export { ArticleCard };
